import Vue from 'vue';
import App from './components/App';
import RefObject from './RefObject';
import utils from './utils';

const { initedClassName, formatValue, genInfo } = utils;
Vue.config.productionTip = false;

const VERSION = process.env.APP_VERSION;
const refObjectCache = [];
utils.initAutoSwipe(refObjectCache);
utils.initJyroSwipe(refObjectCache);

const swipevideo = {
  version: VERSION,
  config: { autoEmbed: true },
  refs: {},
  attach: (elem, value) => {
    if (new RegExp(initedClassName).test(elem.className)) {
      return refObjectCache.find(ref => ref.elem === elem);
    }

    elem.classList.add(initedClassName);

    const param = formatValue(elem, value);

    const refObject = new RefObject(elem);
    refObjectCache.push(refObject);
    refObject.on('$detach', ({ target }) => {
      target.elem.classList.remove(initedClassName);
      const index = refObjectCache.indexOf(target);
      if (index !== -1) refObjectCache.splice(index, 1);
      Object.keys(swipevideo.refs).forEach((ref) => {
        if (swipevideo.refs[ref] === target) {
          swipevideo.refs[ref] = null;
          delete swipevideo.refs[ref];
        }
      });
    });

    if (param.ref) swipevideo.refs[param.ref] = refObject;

    const queryString = param.$auth ? `?${param.$auth}` : '';
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${param.src}/${param.contentId}/info.json${queryString}`);
    xhr.onload = ({ target }) => {
      const root = document.createElement('div');
      elem.appendChild(root);

      const originalInfo = Object.assign({}, target.response, {
        srcset: target.response.srcset.filter(data => Array.isArray(data)),
      });
      const info = genInfo(param, queryString, originalInfo);
      refObject.$setInfo(info, originalInfo);

      /* eslint-disable no-new */
      new Vue({
        el: root,
        template: '<App :info="info" :refObject="refObject"/>',
        components: { App },
        data() {
          refObject.on('$detach', this.$destroy.bind(this));
          return {
            refObject,
            info,
          };
        },
        destroyed() {
          this.$el.parentNode.removeChild(this.$el);
        },
      });
    };
    xhr.responseType = 'json';
    xhr.send();

    return refObject;
  },
  detach: (elem) => {
    const refObject = refObjectCache.find(t => t.elem === elem);
    if (refObject) refObject.detach();
  },
};

if (typeof window === 'object') {
  const embed = () => {
    Array.prototype.forEach.call(document.querySelectorAll('.swipevideo'), (elem) => { swipevideo.attach(elem); });
  };

  // setTimeout for rewriting config
  setTimeout(() => {
    if (swipevideo.config.autoEmbed) {
      if (document.readyState !== 'loading') embed();
      else window.addEventListener('DOMContentLoaded', embed, false);
    }
  });

  /* eslint-disable no-console */
  console.log(`SwipeVideo v${VERSION}`);
}

export default swipevideo;



// WEBPACK FOOTER //
// ./src/swipevideo.js